// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationShoppingStorePath = 'M82.8 42a14.17 14.17 0 01-10.948-4.914A14.607 14.607 0 0161 41.9c-4.336 0-8.25-1.898-10.9-4.867A14.606 14.606 0 0139.2 41.9c-4.31 0-8.204-1.875-10.852-4.814A14.17 14.17 0 0117.6 42.002V83h14V53h38v30h14V41.978a14.84 14.84 0 01-.8.022zm7.8-2.248c3.96-2.493 6.6-6.809 6.6-11.652v-.7L89.7 9H12.6L3 27.2v.9c0 5.24 3.09 9.863 7.6 12.228V83H3v7h94v-7h-6.4V39.752zM62.6 83V60h-24v23h24zm12.8-54.9v-.055V28h-7a7.4 7.4 0 01-14.8 0h-7a7.2 7.2 0 01-7.4 6.9 7.2 7.2 0 01-7.4-6.9h-7v.1a7.2 7.2 0 01-7.4 6.9 7.2 7.2 0 01-7.3-6.2L16.8 16H85l5.1 12.7a7.4 7.4 0 01-14.7-.6z';
var IllustrationShoppingStore = baseIllustration('IllustrationShoppingStore', {
  getPath: () => IllustrationShoppingStorePath
}, 'ColoredIllustrationShoppingStore');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationShoppingStore;
//# sourceMappingURL=index.js.map